export default __webpack_public_path__ + "static/media/me_bored_by_art.5c9a8924.png";